/* eslint-disable max-len */

/**
 * Translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CLOSE: 'Fechar',
    CONFIRM: 'Confirmar',
    CONFIRM_AND_NEXT: 'Confirmar e próximo',
    CONFIRM_AND_SAVE: 'Confirmar e guardar',
    CREATE: 'Criar',
    DELETE: 'Eliminar',
    EDIT: 'Editar',
    NEW_POST: 'Nova publicação',
    OK: 'Ok',
    REJECTED: 'Rejeitada',
    REPLY: 'Responder',
    SAVE: 'Guardar',
    SEND: 'Enviar',
    SKIP_CROP: 'Ignorar corte',
    UPDATE: 'Atualizar',
    UPGRADE: 'Aderir ao club'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'falha ao copiar para a área de transferência!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Ocorreu um erro na partilha do post no Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Ocorreu um erro na partilha do post no Instagram. Deseja avançar com a publicação?',
    LINK_ALREADY_EXISTS: 'Link já existente',
    LINK_VALIDATION_FAILED: 'Não foi possível validar o link',
    MANDATORY_FIELD: 'Campo obrigatório',
    MAXIMUM_CHARACTERS: 'Máximo de caracteres atingidos',
    MAXIMUM_FILE_SIZE: 'O tamanho máximo permitido é de 100MB!',
    MINIMUM_DIMENSIONS:
      'O ficheiro carregado deve ter dimensões mínimas de 480×960',
    PAGE_NOT_APPROVED:
      '❌ Infelizmente, não foi possível aprovar o tua página desta vez. Mas não te preocupes! ✨\n Podes editar o teu perfil e corrigir os campos indicados para reenviar para aprovação.',
    REACTION_LIKE: 'Aconteceu um erro por favor tente mais tarde!',
    UNSUPPORTED_FORMAT: 'Formato não suportado!',
    VIDEO_CROP: 'O corte do vídeo falhou!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Aceito os termos e condições',
    ADDITIONAL_INFORMATION: 'Informação adicional',
    ADDRESS: 'Morada',
    APPROVED: 'publicado',
    ASSETS: 'Imagens ou videos (tamanho máximo 100MB)',
    ASSOCIATE_PRODUCT: 'Associar produto prozis',
    ASSOCIATED_PRODUCTS: 'Produtos prozis associados',
    BUSINESS_PAGE: 'Página de negocio fisico',
    CAPTION: 'Legenda',
    CHART_BY: 'Gráfico por',
    COMMENTS: 'Comentários',
    COMMISSION: 'comissão',
    COMMISSIONS: 'comissões',
    COMMISSIONS_LAST_30_DAYS: 'últimos 30 dias',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Morada completa sem o número da porta',
    CONTINUE_WITH_INSTAGRAM: 'Continuar com o Instagram',
    COUNTRY: 'Morada apenas com o país',
    CREATE_PROFILE: 'Criar perfil',
    CROPPING_ASSET: 'Cortar {asset} {ratio}',
    DELETE_POST: 'Eliminar publicação?',
    DELETE_POST_ARE_YOU_SURE: 'Tem a certeza que deseja eliminar a publicação?',
    DESCRIPTION: 'Biografia',
    DOCUMENT: 'Documento',
    DOWNLOAD: 'Descarregar',
    DRAFT_PROFILE: 'Rascunho',
    EDIT_PROFILE: 'Editar página',
    ENGAGEMENT: 'Interação',
    ERROR: 'Erro',
    FEED: 'feed',
    FOLLOWERS: 'Seguidores',
    FRIDAY: 'Sexta-feira',
    GALLERY: 'Galeria',
    HIDDEN: 'Não apresenta morada',
    IMAGE: 'imagem',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Conta de Instagram',
    LATEST_FIRST: 'Mais recentes primeiro',
    LEAST_PROFITABLE: 'Menos rentáveis primeiro',
    LIKES: 'Gostos',
    LIKES_DELETED: 'Gostos retirados',
    LINK: 'Ligação ',
    LIVE: 'Direto',
    LIVES: 'Diretos',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Morada apenas com cidade e país',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Morada completa',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Morada completa sem o número da porta',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Morada apenas com o país',
    MONDAY: 'Segunda-feira',
    MORE: '... Ver mais',
    MOST_PROFITABLE: 'Mais rentáveis primeiro',
    NAME: 'Nome',
    NEW_FOLLOWERS: 'Novos seguidores',
    NEW_POST: 'Nova publicação',
    NO_PRODUCTS_FOUND: 'Não foi encontrado nenhum produto.',
    NUMBER_OF_FILES: '{file} de {files}',
    OLDEST_FIRST: 'Mais antigas primeiro',
    ORIGINAL: 'Original',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Fotografias de página',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} d',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'pendente',
    POST: 'Publicação',
    POST_COMMENTS: 'Comentários da publicação',
    POST_PRODUCTS: 'Produtos da publicação',
    POST_VIEWS: 'Visualizações de publicações',
    POSTING_ON_INSTAGRAM: 'A publicar no Instagram',
    POSTS: 'Publicações',
    PRODUCTS_HASHTAGS: 'Etiquetas de produtos',
    PRODUCTS_LINKS: 'Ligações de produtos',
    PROFESSIONAL_PAGE: 'Página Profissional',
    PROFILE: 'Perfil',
    PROFILE_PHOTO: 'Foto de perfil',
    PROFILE_STATUS: 'Estado do perfil',
    PROFILE_VIEWS: 'Visualizações do perfil',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Comunidade Prozis',
    QUESTION: 'Questão',
    QUESTION_REPLY: 'Responder à questão',
    QUESTIONS: 'Questões',
    REELS: 'reels',
    REJECTED: 'não publicado',
    REJECTED_PROFILE: 'Rejeitado',
    REJECTION_REASON: 'Motivo da rejeição',
    REPLY: 'Responder',
    REQUIRED_FIELDS: 'Campos obrigatórios',
    RESET: 'Limpar',
    SATURDAY: 'Sábado',
    SEARCH: 'Procurar',
    SEARCH_AT_LEAST:
      'A palavra a pesquisar tem que ter pelo menos 3 caracteres!',
    SEE_LESS: 'Esconder',
    SEE_MORE: 'Ver mais',
    SEE_ORIGINAL: 'Ver original',
    SEE_TRANSLATION: 'Ver tradução',
    SHARE_ON_INSTAGRAM: 'Partilhar no Instagram',
    SHARE_PROFILE: 'Partilhar página',
    SOCIAL_NETWORK: 'Rede social',
    SOCIAL_NETWORK_COMMISSIONS: 'Comissões da rede social',
    SOCIAL_NETWORK_PAGE: 'Página Social',
    SOUND: 'Som',
    SPECIALTIES: 'Especialidades',
    STATISTICS_POST: 'Estatísticas da publicação',
    STATISTICS_PROFILE: 'Estatísticas do perfil',
    STATS_POST_TOTAL: 'Total de comissões da publicação',
    STATS_POST_TOTAL_COMMENTS: 'Comentários/perguntas da publicação',
    STATS_POST_TOTAL_LIKES: 'Gostos obtidos na publicação',
    STATS_POST_TOTAL_PRODUCTS: 'Produtos associados à publicação',
    STATS_POST_TOTAL_QUESTIONS: 'Perguntas respondidas na publicação',
    STATS_POST_TOTAL_VALUE: 'Valor pela publicação',
    STATS_PROFILE_TOTAL: 'Total de comissões em publicações',
    STATS_PROFILE_TOTAL_COMMENTS: 'Comentários/perguntas a publicações',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Novos seguidores angariados',
    STATS_PROFILE_TOTAL_LIKES: 'Gostos obtidos em publicações',
    STATS_PROFILE_TOTAL_POSTS: 'Valor obtido em publicações',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Produtos associados a partir de publicações',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Perguntas respondidas a publicações',
    STORY: 'story',
    SUCCESS: 'Sucesso',
    SUNDAY: 'Domingo',
    TERMS_AND_CONDITIONS: 'Termos e condições',
    THURSDAY: 'Quinta-feira',
    TITLE: 'Título',
    TOTAL_VIEWS: 'Total de visualizações',
    TUESDAY: 'Terça-feira',
    TYPE_OF_DOCUMENT: 'Tipo de documento',
    UNFOLLOWERS: 'Não seguidores',
    UNREAD: 'Por ler',
    UPDATE_POST: 'Atualizar publicação',
    UPDATED: 'Atualizado a {date}',
    UPLOAD: 'Upload de ficheiro',
    UPLOADING_FILES: 'A enviar ficheiro(s)',
    USER_NAME: 'Nome de utilizador',
    VIDEO: 'vídeo',
    VIEW_ALL_COMMENTS: 'Ver os {total} comentários',
    VIEW_MORE: 'Ver mais',
    VIEWS: 'Visualizações',
    VISIBILITY_LEVEL: 'Nivel de visibilidade',
    WAITING_APPROVAL: 'A aguardar aprovação',
    WARNING: 'Aviso',
    WEDNESDAY: 'Quarta-feira',
    YOUR_PROFILE: 'O teu perfil'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Ainda não existem questões.',
    TERMS_AND_CONDITIONS:
      'Ao interagir com a “Rede Social” da Prozis (a título de exemplo e não exaustivamente, fazendo comentários e/ou partilhando conteúdos e reações diretamente), o Utilizador declara ter lido, entendido e aceite os seguintes Termos e Condições (T & C).\n\nA Prozis reserva-se o direito de atualizar os Termos e Condições a qualquer momento, sem aviso prévio. A Prozis terá o direito de operar todos os recursos legais e justos disponíveis.\n\nAo aceder à “Rede Social”, o Utilizador declara ter pelo menos 18 anos de idade e assume toda a responsabilidade por publicações, comentários, imagens e vídeos enviados ("Conteúdo") na própria “Rede social”.\n\nO Conteúdo deve pertencer ao Utilizador, que declara ser o autor e detentor de toda e qualquer propriedade intelectual. O Conteúdo não deve representar qualquer situação, edifício ou objeto particular e/ou protegido por direitos de autor, marca registada ou, em geral, marcas registadas e logotipos de outras empresas, a menos que o Utilizador tenha obtido o consentimento relativo necessário para a sua utilização.\n\nO Conteúdo não deve incluir nenhuma outra pessoa além do Utilizador, a menos que o consentimento seja dado pela mesma pessoa por escrito e cuja obtenção é de responsabilidade do Utilizador. O Utilizador indeminizara e manterá a Prozis ilesa em caso de danos provocados pela utilização de tais imagens e/ou vídeos.\n\nUma vez partilhado, o Conteúdo será da propriedade exclusiva da Prozis, que ficará autorizada a publicar e/ou disseminar e/ou utilizar e/ou reproduzir e/ou comunicar e/ou modificar, por quaisquer meios técnicos e de qualquer forma, o Conteúdo supracitado, sem exclusão, sem prazos e sem direito a qualquer compensação e/ou indemnização para os sujeitos envolvidos e/ou interessados.\n\nApós o possível upload de um conteúdo, a Prozis reserva-se o direito de deixar visível apenas o material que, em seu próprio julgamento inquestionável, não seja prejudicial à imagem dos outros, bem como ofensiva da moral atual, ou de outra forma prejudicial aos direitos dos outros; tendenciosa, difamatória, obscena, vulgar, caluniosa, racista, ou que constitua uma forma de publicidade a qualquer atividade comercial não inerente ao tema proposto ou em qualquer caso que vise promover qualquer marca, produto, serviço diferente do da ”Rede Social”, com Conteúdo não original do Utilizador, ou seja, copiado de outras fontes, com conteúdo em violação do sistema jurídico português, contrariando a decência pública, os regulamentos de privacidade e, em geral, a legislação vigente.\n\nA Prozis também se reserva o direito de excluir, antes ou depois da publicação, qualquer comentário que, a seu exclusivo critério, possa ser ofensivo, inadequado e/ou inconsistente com o espírito da “Rede Social”.\n\nA Prozis também se reserva o direito de, a qualquer momento, remover comentários e/ou conteúdo publicado na sua ”Rede Social”, independentemente ou a pedido de terceiros, bem como Autoridades Judiciais, no caso de disputas relativas à legalidade ou legitimidade da dita publicação ou comentário. Apenas se o Conteúdo for julgado adequado pela moderação da “Rede Social” será o mesmo deixado visível.\n\nApós o carregamento de um Conteúdo na ”Rede Social”, a Prozis reserva-se o direito de fazer upload ou partilhar de novo, diretamente, o Conteúdo do Utilizador nas suas plataformas digitais para promover a sua marca.',
    WITHOUT_POSTS: 'Ainda não existem publicações.',
    WITHOUT_POSTS_STATISTICS:
      'Não existem publicações entre as datas escolhidas.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD:
      'Ligação copiada com sucesso para a área de transferência!',
    CREATED_SUCCESSFULLY: 'Criado com sucesso!',
    ERROR_PUBLISHING_INSAGRAM: 'O post foi publicado no instagram.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'O post foi publicado com sucesso no Instagram.',
    POST_CREATED_SUCCESSFULLY: 'Criada com sucesso!',
    POST_SAVED_SUCCESSFULLY: 'Atualizada com sucesso!',
    POST_SUCCESSFULLY_DELETED: 'Eliminada com sucesso.',
    SAVED_SUCCESSFULLY: 'Atualizado com sucesso!',
    SUCCESSFULLY_DELETED: 'Eliminado com sucesso.',
    SUCCESSFULLY_REPLIED: 'Respondida com sucesso.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS: 'Por favor aceite os termos e condições!',
    EMPTY_PROFILE_IMAGE: 'Deve fazer upload de uma imagem para o perfil!',
    INVALID_FORM: 'Formulário inválido!'
  }
};
